import { render, staticRenderFns } from "./PopsManageFolderInfra.vue?vue&type=template&id=284622b1"
import script from "./PopsManageFolderInfra.vue?vue&type=script&lang=js"
export * from "./PopsManageFolderInfra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports